import React, {Component} from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import Loading from './loading';
import LocalizedStrings from '../localization/strings';

class StagesTable extends Component {

    renderRegistrationButton(stage) {
        if (stage.registration_enabled) {
            if (stage.external_website_registration) {
                return (
                    <a className="btn btn-main-color inline first-uppercase" href={stage.external_registration_link}>{LocalizedStrings.registration}</a>
                )
            }
            return (
                <Link to={`/stages/${stage.id}/registration`} className="btn btn-main-color inline first-uppercase">
                    {LocalizedStrings.registration}
                </Link>
            )
        }
    }

    renderResultsButton(stage) {
        if (stage.has_results) {
            return (
                <Link to={`/stages/${stage.id}/results`} className="btn btn-main-color inline first-uppercase mt-10">
                    {LocalizedStrings.results}
                </Link>
            )
        }
    }

    renderTable(stages) {
        return (
            <table className="table responsive">
                <thead>
                <tr>
                    <th>
                        {LocalizedStrings.stage}
                    </th>
                    <th>
                        {LocalizedStrings.date}
                    </th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {stages.filter((stage) => {
                    return !stage.register_to_all_stages && !stage.global_results_stage && !stage.register_to_custom_stages
                }).map(stage => {
                    return (
                        <tr key={`stage-${stage.id}`}>
                            <td>{stage.name}</td>
                            <td>{moment(stage.stage_date).format('YYYY-MM-DD HH:mm')}</td>
                            <td className="actions">
                                {this.renderRegistrationButton(stage)}
                                {this.renderResultsButton(stage)}
                                {stage.external_website_registration
                                    ? <a className="btn btn-main-color inline first-uppercase" href={stage.external_participants_link}>{LocalizedStrings.participants}</a>
                                    : <Link to={`/stages/${stage.id}/participants`} className="btn btn-main-color inline first-uppercase">
                                        {LocalizedStrings.participants}
                                    </Link>}
                                {stage.external_website_registration
                                    ? <a className="btn btn-main-color inline first-uppercase" href={stage.external_regulations_link}>{LocalizedStrings.regulations}</a>

                                    : <Link to={`/stages/${stage.id}/regulations`} className="btn btn-main-color inline first-uppercase">
                                        {LocalizedStrings.regulations}
                                    </Link>}
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        )
    }

    render() {
        if(this.props.stages.loading){
            return <Loading/>;
        }
        return this.renderTable(this.props.stages.items);
    }
}
export default StagesTable;



// WEBPACK FOOTER //
// ./src/js/components/stages-table.js